<template>
  <entry-status-component :trayOption=false></entry-status-component>
</template>

<script>
import Vue from 'vue'
import EntryStatusComponent from './components/EntryStatusComponent'

export default {
  name: 'ExitPoint',
  components: {
    EntryStatusComponent,
  }
}
</script>
